/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import {
  mainVisualWrapperStyle,
  descriptionWrapperStyle,
  noImageStyle,
  rootStyles,
} from "./styles";

import type { ReactElement } from "react";
import type { FcWithChildren } from "types/fcWithChildren";

type Props = {
  imageElement: ReactElement | null;
};

export const CardBase: FcWithChildren<Props> = (props) => {
  const { children, imageElement } = props;

  return (
    <article css={rootStyles}>
      {imageElement === null ? (
        <div css={noImageStyle}>No image</div>
      ) : (
        <div css={mainVisualWrapperStyle}>{imageElement}</div>
      )}

      <div css={descriptionWrapperStyle}>{children}</div>
    </article>
  );
};
